//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO: PD-271441: Remove once feature is released
export const getIsMultiHandleHashtagTrackingEnabled = createHasFeatureSelector(
  FeatureNames.MultiHandleHashtagTracking,
);
